import React from 'react';
import { Box, Skeleton, Typography } from '@mui/material';

const VerifyPANCardSkeleton2 = () => {
    return (
        <Box sx={{ 
            width: "100%",
            display: "grid",
            gridTemplateColumns: "repeat(1, 1fr)",
            gap: "20px", // space between front and back card
            justifyItems: "center",
            // border: "1px dashed grey",
            // borderRadius: "8px",
            // padding:"10px"
        }}>
            <Typography>Verified Card View</Typography>
            <Box sx={{ padding: "16px", border: "1px dashed grey", borderRadius: "8px" }}>
                <Box sx={{ pt: 0.5 }}>
                    <Skeleton width="80%" />
                    <Skeleton width="60%" />
                </Box>
                <Box sx={{ display: "flex", alignItems: "center", pt: 0.5, pb:1 }}>
                          <Skeleton variant="circular" width={60} height={60} />
                             <Box sx={{ ml: 2 }}>
                                 <Skeleton width="240px" />
                                 <Skeleton width="200PX" />
                             </Box>
                </Box>
                <Skeleton variant="rectangular" width={300} height={"35vh"}  pt={"0.5"} />

               
            </Box>
        </Box>
    );
};

export default VerifyPANCardSkeleton2;
